import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  margin-top: 0.5rem;

  & > .subtitle {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 0.875rem;
  }

  & > .radioContainer {
    margin-bottom: 1rem;
    margin-bottom: 0.875rem;
    display: flex;
    flex-direction: column;
  }

  textarea {
    width: 100%;
  }

  h3 {
    margin-bottom: 1rem;
  }

  .btnContainer {
    height: 9rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    & > button {
      width: 23rem;
    }

    & > button:last-child {
      margin-left: 1.5rem;
    }
  }

  .hefesto-textarea {
    margin-bottom: 1.4rem;
  }
`;
